/**
 * Battery charge, in whole percent, prefilled when the rental order carries no recorded charge.
 * Mirrors the half-full fuel tank the forms fall back to.
 */
export const DEFAULT_BATTERY_CHARGE = 50;
